import React from "react";
import { Search, Server, Code2, ShieldAlert, GraduationCap, ArrowRight } from "lucide-react";

const services = [
  {
    icon: <Search size={20} />,
    title: "Audit d'IA",
    desc: "On analyse votre entreprise et on vous dit exactement où l'IA peut vous faire économiser du temps et de l'argent. Rapport clair inclus.",
  },
  {
    icon: <Server size={20} />,
    title: "Box IA",
    desc: "Un serveur IA installé dans vos locaux en 48h. Aucune donnée ne sort de votre bâtiment, pas d'abonnement cloud.",
  },
  {
    icon: <Code2 size={20} />,
    title: "Logiciels Sur Mesure",
    desc: "Chatbot pour vos employés, traitement automatique de documents, tableaux de bord — construits selon vos besoins réels.",
  },
  {
    icon: <ShieldAlert size={20} />,
    title: "IA Sentinelle",
    desc: "Une IA qui surveille votre réseau 24/7 et vous alerte en cas d'activité suspecte. Idéal pour protéger vos données sensibles.",
  },
  {
    icon: <GraduationCap size={20} />,
    title: "Formation & Loi 25",
    desc: "On s'occupe de mettre votre entreprise en règle avec la Loi 25 et on forme vos employés. Simple et sans stress.",
  },
];

export default function Services() {
  return (
    <section id="solutions" style={{ background: "#ffffff" }} className="section-pad">
      <div className="section-wrap">

        <div style={{ textAlign: "center", marginBottom: "56px" }}>
          <span className="eyebrow">Nos Services</span>
          <h2 className="h-section">
            Ce qu'on fait pour vous
          </h2>
          <p className="body-lg" style={{ maxWidth: "440px", margin: "16px auto 0" }}>
            Des solutions concrètes, installées chez vous, sans jargon technique.
          </p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "16px" }}>
          {services.map((s, i) => (
            <div key={i} className="card-apple" style={{ padding: "28px" }}>
              <div className="icon-pill" style={{ marginBottom: "16px" }}>{s.icon}</div>
              <h3 style={{ fontFamily: "'Plus Jakarta Sans'", fontSize: "1.0625rem", fontWeight: 700, color: "#1d1d1f", letterSpacing: "-0.02em", marginBottom: "10px" }}>
                {s.title}
              </h3>
              <p style={{ fontSize: "0.875rem", color: "#6e6e73", lineHeight: 1.65 }}>{s.desc}</p>
              <a href="#contact"
                 style={{ marginTop: "20px", display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "0.875rem", fontWeight: 600, color: "#0071e3", textDecoration: "none", fontFamily: "'Plus Jakarta Sans'" }}>
                En savoir plus <ArrowRight size={13} />
              </a>
            </div>
          ))}

          <div style={{
            background: "linear-gradient(145deg, #0071e3 0%, #0a84ff 100%)",
            borderRadius: "20px", padding: "28px",
            display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: "220px",
          }}>
            <div>
              <h3 style={{ fontFamily: "'Plus Jakarta Sans'", fontSize: "1.125rem", fontWeight: 700, color: "#fff", lineHeight: 1.3 }}>
                Un besoin spécifique?
              </h3>
              <p style={{ marginTop: "10px", fontSize: "0.875rem", color: "rgba(255,255,255,0.8)", lineHeight: 1.6 }}>
                Parlez-nous de votre situation — on trouve une solution ensemble, gratuitement.
              </p>
            </div>
            <a href="#contact"
               style={{ marginTop: "20px", display: "inline-flex", alignItems: "center", gap: "8px", background: "#fff", color: "#0071e3", borderRadius: "999px", padding: "11px 22px", fontSize: "0.875rem", fontWeight: 700, fontFamily: "'Plus Jakarta Sans'", textDecoration: "none", width: "fit-content" }}>
              Nous contacter <ArrowRight size={14} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
